import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import QRCode from 'react-qr-code'
import config from '@/config'
import { useNavigate } from 'react-router'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',

    '& > *:not(:first-child)': {
      paddingLeft: 30,
    },
  },
  imageRow: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 15,
  },
  title: {
    paddingTop: 40,
    color: '#50586c',
    display: 'block',
    fontSize: 14,
    lineHeight: '1.25em',
  },
  subtitle: {
    color: '#50586c',
    display: 'block',
    fontSize: 13,
    lineHeight: '1.25em',
  },
}))

const AppStoreBadges = (props) => {
  const navigate = useNavigate()
  const { hideText = false, className, documents } = props
  const classes = useStyles()

  const link = useMemo(() => {
    if (documents) {
      return config.marketingUrlDocuments
    }
    return config.marketingUrl
  }, [documents])

  const onClick = () => {
    window.open(link, '_blank')
  }
  const onDocumentClick = () => {
    navigate('/documents')
  }

  const textElements = (
    <div className={classes.text}>
      <p className={classes.title}>{lang.expense.uploader.textTitle}</p>
      <p className={classes.subtitle}>Du kannst Dokumente über den<a onClick={onDocumentClick}> Dokumentenbereich</a><br></br>oder unsere Apps für Android oder iOS hinzufügen.</p>
    </div>)

  return (
    <div className={clsx(classes.root, className)}>
      { !hideText && textElements}
      <div className={classes.row}>
        <div className={classes.imageRow}>
          <QRCode value={link ?? ''} level='Q' size={160} onClick={onClick} />
        </div>
      </div>
    </div>
  )
}

AppStoreBadges.propTypes = {
  hideText: PropTypes.bool,
  documents: PropTypes.bool,
}

export default AppStoreBadges
